import NavLink from 'react-router-dom/NavLink';
import React from 'react';
import PropTypes from 'prop-types';
import Icon from '../Icon';
import MainLinkBadge from '../MainLinkBadge';
import './styles.css';

const MainLink = ({ to, icon, label, hasBadge, badgeCount }) => 
	<NavLink to={to} className="main-link">
		<div className="main-link-content">
			<Icon icon={icon} />
			{hasBadge && <MainLinkBadge label={badgeCount} />}
			<div className="main-link-label">{label}</div>
		</div>
	</NavLink>
;

MainLink.propTypes = {
	to: PropTypes.string.isRequired,
	icon: PropTypes.string,
	label: PropTypes.string, // string: id del dizionario
	active: PropTypes.bool.isRequired,
	hasBadge: PropTypes.bool,
	badgeCount: PropTypes.number
};

export default MainLink;
